import React from "react";
import injectSheet from "react-jss";
import classNames from "classnames";
import { globalTheme } from "../../styles/globalTheme";

const SmallBluebutton = ({
  classes,
  children,
  disabled,
  name,
  value,
  onClick,
  fake,
  className,
}) =>
  fake ? (
    <div className={classNames(classes.button, className)}>{children}</div>
  ) : (
    <button
      type="button"
      disabled={disabled === true ? disabled : false}
      name={name ? name : ""}
      className={classNames(classes.button, className)}
      value={value ? value : ""}
      onClick={disabled === true ? () => {} : onClick}
    >
      {children}
    </button>
  );

const styles = (theme) => ({
  button: {
    padding: (props) => (props.padding ? props.padding : "6px 16px"),
    fontSize: (props) => (props.fontSize ? props.fontSize : "14px"),
    borderRadius: "4px",
    border: "solid 1px " + theme.actionButtonColor, //"solid 1px #335cda",
    color: "#ffffff",
    backgroundColor: theme.actionButtonColor, //"#335cda",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      border: "solid 1px " + theme.menuDarkColor, //"solid 1px #182d58",
      backgroundColor: theme.menuDarkColor, //"#182d58",
      "& svg path": {
        fill: `${theme.menuDarkColor} !important`, //"#182d58!important",
      },
    },
    "&:focus": {
      outline: (props) =>
        props.noFocus ? null : globalTheme.outline,
    },
  },
});
export default injectSheet(styles)(SmallBluebutton);
